<template>
  <div class="space-y-16">
    <component
      :is="getComponent(metric)"
      v-for="metric in metrics?.pricing"
      :key="metric.code"
      :metric
      @on-update="refresh"
    />
  </div>
</template>

<script setup lang="ts">
import type { Component } from 'vue'

import { sellerOpportunities } from '@backmarket/http-api'
import { useHttpFetch } from '@backmarket/nuxt-module-http/useHttpFetch'

import { OPPORTUNITIES_TYPES as BACKBOXES_TO_BOOST } from './components/BlockBackboxesToBoost/BlockBackboxesToBoost.constants'
import BackboxesToBoost from './components/BlockBackboxesToBoost/BlockBackboxesToBoost.vue'
import { OPPORTUNITIES_TYPES as LISTINGS_IN_TROUBLE } from './components/BlockListingsInTrouble/BlockListingsInTrouble.constants'
import ListingsInTrouble from './components/BlockListingsInTrouble/BlockListingsInTrouble.vue'
import { OPPORTUNITIES_TYPES as QUICK_WIN } from './components/BlockQuickWins/BlockQuickWins.constants'
import QuickWins from './components/BlockQuickWins/BlockQuickWins.vue'

const { data: metrics, refresh } = await useHttpFetch(
  sellerOpportunities.getPricingOpportunitiesMetrics,
)

function getComponent(metric: { code: string }) {
  const componentByCode = {
    [QUICK_WIN]: QuickWins,
    [LISTINGS_IN_TROUBLE]: ListingsInTrouble,
    [BACKBOXES_TO_BOOST]: BackboxesToBoost,
  } as Record<string, Component>

  return componentByCode[metric.code] || 'span'
}
</script>
